import { Box, Grid, Typography } from '@mui/material'
import { StockProjectionExceptionsGraph } from 'Features/NewDashboard/StockProjection/StockProjection.graph'
import { useTheme } from '@mui/material/styles'
import { useStockProjection } from './SourceSiteDashboard.data'
import { useParams } from 'react-router-dom'
import { Loader } from 'Common/Loader/Loader'
import { formatDateWithHiphen } from 'Common/utils/utils'
import {
  GraphViewProps,
  SourceSiteDashboardPageURLParams,
} from './SourceSiteDashboard.types'

export const StockProjectionView = ({ workcentresList }: GraphViewProps) => {
  const theme = useTheme()
  const { planId } = useParams<SourceSiteDashboardPageURLParams>()
  const { data: stockProjectionData, isLoading: stockProjectionDataLoading } =
    useStockProjection({
      planId: planId ?? '',
      workcentresList,
    })

  const kpis = stockProjectionData?.kpis ?? {}

  if (stockProjectionDataLoading) {
    return <Loader />
  }
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Grid container>
        <Grid size={4}>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            Total projected
          </Typography>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            stock-outs
          </Typography>
          <Typography
            variant="h2"
            sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}
          >
            {kpis?.totalProjectedStockOut ?? 0}
          </Typography>
        </Grid>
        <Grid size={4}>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            Total projected
          </Typography>
          <Typography
            variant="body1"
            sx={{ lineHeight: 1.25, color: theme.palette.text.secondary }}
          >
            low stock warnings
          </Typography>
          <Typography
            variant="h2"
            sx={{ fontWeight: 'bold', color: theme.palette.text.primary }}
          >
            {kpis?.totalProjectedLowStock ?? 0}
          </Typography>
        </Grid>
        <Grid size={4}></Grid>
      </Grid>
      <Box>
        <StockProjectionExceptionsGraph
          xAxisData={stockProjectionData?.week.map(formatDateWithHiphen) ?? []}
          stockProjectionAlertData={
            stockProjectionData?.stockProjectionAlert ?? []
          }
          stockProjectionExceptionData={
            stockProjectionData?.stockProjectionException ?? []
          }
          stockProjectionOkData={stockProjectionData?.stockProjectionOk ?? []}
        />
      </Box>
    </Box>
  )
}
